module.exports = __webpack_public_path__ + "a9832e49829c4868484414a294367f06.png";